import { AddonItem } from '@intigral/shared/components/AddonItem';
import { Button } from '@intigral/shared/components/Button';
import { isUserInGracePeriod } from '@intigral/utils';
import { useDispatch } from 'react-redux';
import h from '../../../../helpers/common';
import useLanguage from '../../../../hooks/useLanguage';
import { __ } from '../../../../translations';
import { showUpgradedModal } from '../../../../store/reducers/generalConfigurationSlice';
import { AddonRegularItemProps } from '../../types/iAddonsCarousel';
import { useAddonsRedirection } from '../../hooks/useAddonsRedirection';
import { useBundleAndSaveRules } from '../../hooks/useBundleAndSaveRules';

export const AddonRegularItem: React.FC<AddonRegularItemProps> = ({ item, index, config, carousel }) => {
    const dispatch = useDispatch();
    const language = useLanguage();
    const { redirectToAddonsPage, redirectToAddonsDetailsPage } = useAddonsRedirection();
    const isGracePeriod = isUserInGracePeriod();
    const showUpdatePayment = Boolean(item?.isSuspendedAddon) || (isGracePeriod && Boolean(item?.isGracePeriodAddon));
    const { data: bundleAndSaveRules, isEnabled: isEnabledBundleAndSave } = useBundleAndSaveRules();
    const discountRules = bundleAndSaveRules?.data?.discountRules;

    const openGracePeriodModal = () => dispatch(showUpgradedModal(true));
    const showNotIncludedFlag =
        !item?.isPickAndChoose && isEnabledBundleAndSave && discountRules?.length > 0 && !item?.isBundleAndSave;
    return (
        <AddonItem
            prefix={item?.serviceCollectionId ? '' : __('addon_text_from')}
            suffix={item?.serviceCollectionId ? '' : `/${__('subscription_month')}`}
            cost={item?.serviceCollectionId ? '' : item?.cost}
            currency={item?.serviceCollectionId ? '' : item?.currency}
            logo={item.logo}
            status={item?.showOnUs ? __('pick_and_choose_on_us_text') : item.status}
            picture={h.getImagizerUrl(item.mainImage, config?.imagizer?.components_images.VOD_ITEM)}
            statusColor={item?.statusColor}
            statusIconName={item?.statusIconName}
            statusIconColor={item?.statusIconColor}
            ctaPlay={
                showUpdatePayment ? (
                    <Button compact onClick={() => openGracePeriodModal()}>
                        {__('update_payment_cta')}
                    </Button>
                ) : item.status == '' ? (
                    <Button
                        compact
                        onClick={() => {
                            if (isGracePeriod) {
                                openGracePeriodModal();
                            } else {
                                redirectToAddonsPage(item, carousel);
                            }
                        }}
                    >
                        {__('addon_subscribe_now_button')}
                    </Button>
                ) : (
                    <Button
                        compact
                        secondary
                        onClick={() => {
                            redirectToAddonsPage(item, carousel);
                        }}
                    >
                        {__('manage_addon_button')}
                    </Button>
                )
            }
            ctaDetails={
                <Button
                    compact
                    plain
                    onClick={() => {
                        redirectToAddonsDetailsPage(item, carousel);
                    }}
                >
                    {__('details')}
                </Button>
            }
            info={[]}
            isStatic={false}
            flag={showNotIncludedFlag ? __('addOn_bundle_n_save_not_included_text') : undefined}
        />
    );
};
